import { initApiRequest } from "lib/api-request";
import { useQuery } from "react-query";
import { dashboardApi } from "./dashboard.api";



const {ongoingTraining,dashboardCount} = dashboardApi;
export const useGetOngoingTraining = (filter:string, enabled?: boolean) => {
  return useQuery({
    queryKey: [ongoingTraining.actionName],
    queryFn() {
      return initApiRequest<BackendSuccessResponse<any>>({
        apiDetails: ongoingTraining,
        params:{
            filter:filter
        }
      });
    },
    enabled,
    select(data) {
      return data?.data.data;
    },
  });
};

export const useGetDashboardCount = (enabled?: boolean) => {
  return useQuery({
    queryKey: [dashboardCount.actionName],
    queryFn() {
      return initApiRequest<BackendSuccessResponse<any>>({
        apiDetails: dashboardCount,
      
      });
    },
    enabled,
    select(data) {
      return data?.data.data;
    },
  });
};
// export const useGetShiftById = (id: number, enabled?: boolean) => {
//   return useQuery({
//     queryKey: [GetShiftById.actionName],
//     queryFn() {
//       return initApiRequest<BackendSuccessResponse<any>>({
//         apiDetails: GetShiftById,
//         params: { id }
//       });
//     },
//     enabled,
//     select(data) {
//       return data?.data.Data;
//     },
//   });
// };
// export const useUpdateShift = () => {
//   const queryClient = useQueryClient();
//   return useMutation({
//     mutationKey: [UpdateShift.actionName],
//     mutationFn(requestData: ShiftFormSubmitType) {
//       return initApiRequest<BackendSuccessResponse<unknown>>({
//         apiDetails: UpdateShift,
//         requestData,
//       });
//     },
//     onSuccess() {
//       queryClient.invalidateQueries({ queryKey: [GetShiftList.actionName] });
//     },
//   });
// };

// export const useAdminLogin = () => {
//   const queryClient = useQueryClient();
//   return useMutation({
//     mutationKey: [AdminLogin.actionName],
//     mutationFn(requestData: LoginInterface) {
//         return initApiRequest<BackendSuccessResponse<LoginResponseData>>({
//         apiDetails: AdminLogin,
//         requestData,
//       })

    
//     },
//     onSuccess() {
//     },
//   });
// };
// export const useDeleteShift = () => {
//   const queryClient = useQueryClient();
//   return useMutation({
//     mutationKey: [DeleteShiftById.actionName],
//     mutationFn({ id }: { id: number }) {
//       return initApiRequest<BackendSuccessResponse<unknown>>({
//         apiDetails: DeleteShiftById,
//         params: { id },
//       });
//     },
//     onSuccess() {
//       queryClient.invalidateQueries({ queryKey: [GetShiftList.actionName] });
//     },
   
//   });
// };

// export const useGetBranchList = (enabled?: boolean) => {
//   return useQuery({
//     queryKey: ['GET_BRANCH_LIST'],
//     queryFn: () => initApiRequest({ apiDetails: GetBranchDropdown }),
//     enabled,
//     select: (res: any) => res?.data, 
//   });
// };